import { createDuck } from '@/utils'
import { getRecommend } from '@/services/api/common'
// import { PRODUCT_STATUS_MAP, SHOP_ID, VIDEO_STATUS } from '@/utils/const'
import {
  delOrder,
  refoundOrder,
  getOrderDetailById,
  cancelOrder,
  receiveOrder,
} from '@/services/api/orders'
import { Toast } from '@bcz/nib'
import { ORDER_ACTIONS_TYPES } from '@/utils/mineConst'
/** @type {orders.OrderItemType} */
export const DEFAULT_STATUS = {}
export const duck = createDuck({
  name: 'orderDetailDuck',
  /** @type {{[key: number|string]: {status: number,order:orders.OrderItemType,isFolder: boolean,recommendList: Array<GoodItemInfo>}}} */
  initialState: {},
  actions: {
    initPage() {},
    /**
     * 获取订单列表
     * @param {number} orderId

     * @returns
     */
    fetchData(orderId) {
      return async (dispatch, getState) => {
        const { data, error } = await getOrderDetailById(orderId)
        if (!error) {
          const _curTime = new Date().getTime()
          const { orderDetailDuck } = getState()
          const { nowTime } = data
          // const _newD = formatPrePayment({ nowTime, stepPay, stepPayOrders, status })
          window.TIME_DIFF = nowTime ? nowTime - _curTime : 0
          dispatch(
            duck.change({
              ...orderDetailDuck,
              [orderId]: {
                status: 1,
                isFolder: true,
                order: { ...data },
              },
            }),
          )
        }
      }
    },
    /**
     * 删除订单
     * @param {number} orderId
     * @returns
     */
    del(orderId) {
      return async () => {
        const { error } = await delOrder(orderId)
        if (!error) {
          return ORDER_ACTIONS_TYPES.DEL
        } else {
          Toast.show('订单删除失败，请稍后重试')
        }
      }
    },

    /**
     * 取消订单
     * @param {number} orderId
     * @returns
     */
    cancel(orderId) {
      return async () => {
        const { error } = await cancelOrder(orderId)
        if (!error) {
          return ORDER_ACTIONS_TYPES.CANCEL
        } else {
          Toast.show('订单取消失败，请重试')
        }
      }
    },

    /**
     * 申请退款
     * @param {number} orderId
     * @returns
     */
    refound(orderId) {
      return async dispatch => {
        const { error } = await refoundOrder(orderId)
        if (!error) {
          dispatch(duck.fetchData(orderId))
        } else {
          Toast.show('退款失败，请联系客服处理')
        }
      }
    },

    /**
     * 签收订单 确认收货
     * @param {number} orderId
     * @returns
     */
    receive(orderId) {
      return async () => {
        const { error } = await receiveOrder(orderId)
        if (!error) {
          return ORDER_ACTIONS_TYPES.RECEIVE

          // dispatch(duck.fetchData(orderId))
        } else {
          Toast.show('确认收货失败，请稍后重试')
        }
      }
    },
    getRecommendData() {
      return async (dispatch, getState) => {
        const { error, data } = await getRecommend()

        if (!error) {
          const { orderDetailDuck } = getState()
          dispatch(
            duck.change({
              ...orderDetailDuck,
              recommendList: data,
            }),
          )
        }
      }
    },
    changeFolderStatus(val, orderId) {
      return async (dispatch, getState) => {
        const { orderDetailDuck } = getState()
        dispatch(
          duck.change({
            ...orderDetailDuck,
            [orderId]: {
              ...orderDetailDuck[orderId],
              isFolder: val,
            },
          }),
        )
      }
    },
  },
})
